import React, { ReactNode, createContext, useContext, useRef } from 'react';

import { usePlaygroundSecrets } from '../components/PlaygroundSecrets.utils';
import { useManifests } from './hooks/usePlaygroundStore';

interface SecretsContextType {
  secrets: Record<string, string>;
  setSecrets: (secrets: Record<string, string>) => void;
  openSecretsRef: React.RefObject<() => void | null>;
  dedicatedOpenAISecret: string;
}

const SecretsContext = createContext<SecretsContextType | undefined>(undefined);

export const useSecrets = (): SecretsContextType => {
  const context = useContext(SecretsContext);
  if (!context) {
    throw new Error('useSecrets must be used within a SecretsProvider');
  }
  return context;
};

interface SecretsProviderProps {
  children: ReactNode;
}

export const SecretsProvider: React.FC<SecretsProviderProps> = ({
  children,
}) => {
  const manifests = useManifests();
  // get all of the secrets we need from the models that we're using
  const [secrets, setSecrets, dedicatedOpenAISecret] = usePlaygroundSecrets({
    serialized: manifests,
  });
  const openSecretsRef = useRef<(() => void) | null>(null);

  return (
    <SecretsContext.Provider
      value={{ secrets, setSecrets, openSecretsRef, dedicatedOpenAISecret }}
    >
      {children}
    </SecretsContext.Provider>
  );
};
